import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderSubscriptionsModal = () => openPopupHelper({ popupName: popupNames.SUBSCRIPTIONS_MOBILE });
